// Multi-language translations for FeelAtHomeNow website

export const translations = {
  de: {
    // Navigation
    nav: {
      home: "Startseite",
      apartments: "Wohnungen",
      forCompanies: "Für Unternehmen",
      forPropertyManagers: "Für Immobilienverwalter",
      about: "Über uns",
      contact: "Kontakt",
    },

    // Hero Section
    hero: {
      headline: "Ihr Zuhause in der Schweiz",
      subheadline: "Möblierte Business-Apartments und flexible Wohnlösungen für Expats, Professionals und Unternehmen.",
      cta1: "Wohnungen finden",
      cta2: "Wohnungen für Mitarbeiter",
    },

    // Services Section
    services: {
      title: "Unsere Wohnlösungen",
      subtitle: "Professionelle und flexible Unterkünfte in der Schweiz",
      service1Title: "Business Apartments",
      service1Desc: "Vollmöblierte Apartments für Geschäftsreisende und Professionals",
      service2Title: "Co-Living",
      service2Desc: "Moderne gemeinschaftliche Wohnlösungen für junge Professionals",
      service3Title: "Expat Housing",
      service3Desc: "Temporäre Unterkünfte für Expats, die in die Schweiz ziehen",
      service4Title: "Unternehmensunterkünfte",
      service4Desc: "Massgeschneiderte Wohnlösungen für umziehende Mitarbeiter",
    },

    // Benefits for Companies
    companies: {
      title: "Vorteile für Unternehmen",
      subtitle: "Professionelle Wohnlösungen für Ihre umziehenden Mitarbeiter",
      benefit1Title: "Schnelle Verfügbarkeit",
      benefit1Desc: "Sofort verfügbare, vollmöblierte Apartments in Top-Lagen",
      benefit2Title: "Flexible Verträge",
      benefit2Desc: "Kurz- und langfristige Mietverträge nach Ihren Bedürfnissen",
      benefit3Title: "All-Inclusive Service",
      benefit3Desc: "Einrichtung, Nebenkosten, Internet – alles inklusive",
      benefit4Title: "Mehrere Standorte",
      benefit4Desc: "Apartments in Zürich, Genf, Basel und Zug verfügbar",
      cta: "Mehr über Unternehmenslösungen",
    },

    // Benefits for Property Managers
    propertyManagers: {
      title: "Vorteile für Immobilienverwalter",
      subtitle: "Zuverlässige Mieter und langfristige Partnerschaften",
      benefit1Title: "Zuverlässige Mieter",
      benefit1Desc: "Geprüfte Mieter mit langfristigen Verträgen",
      benefit2Title: "Professionelle Verwaltung",
      benefit2Desc: "Wir kümmern uns um die gesamte Mietverwaltung",
      benefit3Title: "Garantierte Zahlungen",
      benefit3Desc: "Pünktliche und sichere Mietzahlungen",
      benefit4Title: "Immobilienpflege",
      benefit4Desc: "Professionelle Betreuung und Pflege Ihrer Immobilien",
      cta: "Partner werden",
    },

    // About Section
    about: {
      title: "Über FeelAtHomeNow",
      subtitle: "Ihr zuverlässiger Partner für temporäres Wohnen in der Schweiz",
      text1: "FeelAtHomeNow ist Ihr professioneller Partner für möblierte Business-Apartments und flexible Wohnlösungen in der Schweiz.",
      text2: "Wir bieten hochwertige Unterkünfte für Expats, Professionals, Studenten und Unternehmen, die Mitarbeiter umziehen.",
      text3: "Unsere Mission ist es, jedem das Gefühl zu geben, in der Schweiz zuhause zu sein – mit professionellem Service, erstklassigen Apartments und persönlicher Betreuung.",
      cta: "Mehr erfahren",
    },

    // Contact Section
    contact: {
      title: "Kontaktieren Sie uns",
      subtitle: "Wir helfen Ihnen gerne bei der Suche nach Ihrer perfekten Unterkunft",
      namePlaceholder: "Name",
      emailPlaceholder: "E-Mail",
      phonePlaceholder: "Telefon",
      companyPlaceholder: "Unternehmen (optional)",
      messagePlaceholder: "Ihre Nachricht",
      submit: "Anfrage senden",
      successMessage: "Vielen Dank! Wir melden uns in Kürze bei Ihnen.",
    },

    // Footer
    footer: {
      tagline: "Ihr Zuhause in der Schweiz",
      quickLinks: "Schnelllinks",
      services: "Dienstleistungen",
      locations: "Standorte",
      zurich: "Zürich",
      geneva: "Genf",
      basel: "Basel",
      zug: "Zug",
      rights: "Alle Rechte vorbehalten.",
    },

    // Apartments Page
    apartmentsPage: {
      title: "Unsere Apartments",
      subtitle: "Hochwertige möblierte Wohnungen an Top-Standorten",
      filterAll: "Alle",
      filterZurich: "Zürich",
      filterGeneva: "Genf",
      filterBasel: "Basel",
      filterZug: "Zug",
      perMonth: "pro Monat",
      viewDetails: "Details ansehen",
      bedrooms: "Schlafzimmer",
      bathrooms: "Badezimmer",
      sqm: "m²",
    },

    // For Companies Page
    companiesPage: {
      title: "Wohnlösungen für Unternehmen",
      subtitle: "Professionelle Unterkünfte für Ihre umziehenden Mitarbeiter",
      heroText: "Wir bieten massgeschneiderte Wohnlösungen für Unternehmen, die Mitarbeiter in die Schweiz umziehen. Von kurzen Geschäftsreisen bis zu langfristigen Projekten.",
      whyTitle: "Warum FeelAtHomeNow?",
      feature1Title: "Zentrale Standorte",
      feature1Desc: "Apartments in der Nähe von Geschäftszentren und öffentlichen Verkehrsmitteln",
      feature2Title: "Flexible Laufzeiten",
      feature2Desc: "Von wenigen Wochen bis zu mehreren Jahren",
      feature3Title: "Komplettservice",
      feature3Desc: "Möblierung, Einrichtung, Internet und alle Nebenkosten inklusive",
      feature4Title: "Dedizierter Support",
      feature4Desc: "Persönlicher Ansprechpartner für Ihre Bedürfnisse",
      ctaTitle: "Starten Sie heute",
      ctaText: "Kontaktieren Sie uns für eine massgeschneiderte Lösung für Ihr Unternehmen.",
      ctaButton: "Jetzt anfragen",
    },

    // For Property Managers Page
    propertyManagersPage: {
      title: "Für Immobilienverwalter",
      subtitle: "Werden Sie unser Partner und profitieren Sie von zuverlässigen Mietern",
      heroText: "FeelAtHomeNow sucht langfristige Partnerschaften mit Immobilieneigentümern und Verwaltern in der Schweiz. Wir bieten professionelle Verwaltung und garantierte Mietzahlungen.",
      benefitsTitle: "Ihre Vorteile",
      benefit1Title: "Langfristige Verträge",
      benefit1Desc: "Mehrjährige Mietverträge mit garantierten Zahlungen",
      benefit2Title: "Professionelle Mieter",
      benefit2Desc: "Geprüfte internationale Geschäftsleute und Unternehmen",
      benefit3Title: "Immobilienpflege",
      benefit3Desc: "Professionelle Betreuung und regelmässige Wartung",
      benefit4Title: "Transparenz",
      benefit4Desc: "Klare Kommunikation und regelmässige Updates",
      ctaTitle: "Interesse an einer Partnerschaft?",
      ctaText: "Kontaktieren Sie uns und erfahren Sie mehr über die Zusammenarbeit.",
      ctaButton: "Partner werden",
    },

    // About Page
    aboutPage: {
      title: "Über FeelAtHomeNow",
      subtitle: "Wir schaffen ein Zuhause für internationale Professionals in der Schweiz",
      missionTitle: "Unsere Mission",
      missionText: "FeelAtHomeNow wurde gegründet, um internationalen Professionals, Expats, Studenten und Unternehmen den Start in der Schweiz zu erleichtern. Mit flexiblen Wohnkonzepten – von möblierten Apartments bis zu bezahlbarem Co-Living – schaffen wir attraktiven Wohnraum auch in gefragten Städten wie Zürich. Unser Ziel ist es, nicht nur Unterkunft anzubieten, sondern ein echtes Zuhause auf Zeit.",
      visionTitle: "Unsere Vision",
      visionText: "Wir wollen der führende Anbieter für flexible Wohnlösungen in der Schweiz werden – bekannt für Qualität, Service und Zuverlässigkeit.",
      valuesTitle: "Unsere Werte",
      value1: "Qualität",
      value1Desc: "Hochwertige Apartments an erstklassigen Standorten",
      value2: "Service",
      value2Desc: "Persönlicher und professioneller Kundenservice",
      value3: "Flexibilität",
      value3Desc: "Massgeschneiderte Lösungen für individuelle Bedürfnisse",
      value4: "Zuverlässigkeit",
      value4Desc: "Vertrauenswürdige Partnerschaften und garantierte Leistungen",
    },
  },

  en: {
    // Navigation
    nav: {
      home: "Home",
      apartments: "Apartments",
      forCompanies: "For Companies",
      forPropertyManagers: "For Property Managers",
      about: "About",
      contact: "Contact",
    },

    // Hero Section
    hero: {
      headline: "Your Home in Switzerland",
      subheadline: "Furnished business apartments and flexible housing solutions for expats, professionals and companies.",
      cta1: "Find Apartments",
      cta2: "Housing for Employees",
    },

    // Services Section
    services: {
      title: "Our Housing Solutions",
      subtitle: "Professional and flexible accommodations in Switzerland",
      service1Title: "Business Apartments",
      service1Desc: "Fully furnished apartments for business travelers and professionals",
      service2Title: "Co-Living",
      service2Desc: "Modern shared living solutions for young professionals",
      service3Title: "Expat Housing",
      service3Desc: "Temporary accommodations for expats moving to Switzerland",
      service4Title: "Corporate Housing",
      service4Desc: "Tailored housing solutions for relocating employees",
    },

    // Benefits for Companies
    companies: {
      title: "Benefits for Companies",
      subtitle: "Professional housing solutions for your relocating employees",
      benefit1Title: "Immediate Availability",
      benefit1Desc: "Fully furnished apartments available immediately in prime locations",
      benefit2Title: "Flexible Contracts",
      benefit2Desc: "Short and long-term rental agreements tailored to your needs",
      benefit3Title: "All-Inclusive Service",
      benefit3Desc: "Furniture, utilities, internet – everything included",
      benefit4Title: "Multiple Locations",
      benefit4Desc: "Apartments available in Zurich, Geneva, Basel and Zug",
      cta: "Learn more about corporate solutions",
    },

    // Benefits for Property Managers
    propertyManagers: {
      title: "Benefits for Property Managers",
      subtitle: "Reliable tenants and long-term partnerships",
      benefit1Title: "Reliable Tenants",
      benefit1Desc: "Vetted tenants with long-term contracts",
      benefit2Title: "Professional Management",
      benefit2Desc: "We handle all rental management for you",
      benefit3Title: "Guaranteed Payments",
      benefit3Desc: "Timely and secure rental payments",
      benefit4Title: "Property Care",
      benefit4Desc: "Professional maintenance and care of your properties",
      cta: "Become a Partner",
    },

    // About Section
    about: {
      title: "About FeelAtHomeNow",
      subtitle: "Your reliable partner for temporary housing in Switzerland",
      text1: "FeelAtHomeNow is your professional partner for furnished business apartments and flexible housing solutions in Switzerland.",
      text2: "We provide high-quality accommodations for expats, professionals, students and companies relocating employees.",
      text3: "Our mission is to make everyone feel at home in Switzerland – with professional service, premium apartments and personal care.",
      cta: "Learn more",
    },

    // Contact Section
    contact: {
      title: "Contact Us",
      subtitle: "We're happy to help you find your perfect accommodation",
      namePlaceholder: "Name",
      emailPlaceholder: "Email",
      phonePlaceholder: "Phone",
      companyPlaceholder: "Company (optional)",
      messagePlaceholder: "Your message",
      submit: "Send Inquiry",
      successMessage: "Thank you! We will get back to you shortly.",
    },

    // Footer
    footer: {
      tagline: "Your Home in Switzerland",
      quickLinks: "Quick Links",
      services: "Services",
      locations: "Locations",
      zurich: "Zurich",
      geneva: "Geneva",
      basel: "Basel",
      zug: "Zug",
      rights: "All rights reserved.",
    },

    // Apartments Page
    apartmentsPage: {
      title: "Our Apartments",
      subtitle: "Premium furnished apartments in top locations",
      filterAll: "All",
      filterZurich: "Zurich",
      filterGeneva: "Geneva",
      filterBasel: "Basel",
      filterZug: "Zug",
      perMonth: "per month",
      viewDetails: "View Details",
      bedrooms: "Bedrooms",
      bathrooms: "Bathrooms",
      sqm: "sqm",
    },

    // For Companies Page
    companiesPage: {
      title: "Housing Solutions for Companies",
      subtitle: "Professional accommodations for your relocating employees",
      heroText: "We provide tailored housing solutions for companies relocating employees to Switzerland. From short business trips to long-term projects.",
      whyTitle: "Why FeelAtHomeNow?",
      feature1Title: "Central Locations",
      feature1Desc: "Apartments near business centers and public transportation",
      feature2Title: "Flexible Terms",
      feature2Desc: "From a few weeks to several years",
      feature3Title: "Full Service",
      feature3Desc: "Furniture, setup, internet and all utilities included",
      feature4Title: "Dedicated Support",
      feature4Desc: "Personal contact person for your needs",
      ctaTitle: "Get Started Today",
      ctaText: "Contact us for a customized solution for your company.",
      ctaButton: "Request Now",
    },

    // For Property Managers Page
    propertyManagersPage: {
      title: "For Property Managers",
      subtitle: "Become our partner and benefit from reliable tenants",
      heroText: "FeelAtHomeNow seeks long-term partnerships with property owners and managers in Switzerland. We offer professional management and guaranteed rental payments.",
      benefitsTitle: "Your Benefits",
      benefit1Title: "Long-Term Contracts",
      benefit1Desc: "Multi-year rental agreements with guaranteed payments",
      benefit2Title: "Professional Tenants",
      benefit2Desc: "Vetted international business people and companies",
      benefit3Title: "Property Care",
      benefit3Desc: "Professional maintenance and regular upkeep",
      benefit4Title: "Transparency",
      benefit4Desc: "Clear communication and regular updates",
      ctaTitle: "Interested in a Partnership?",
      ctaText: "Contact us to learn more about working together.",
      ctaButton: "Become a Partner",
    },

    // About Page
    aboutPage: {
      title: "About FeelAtHomeNow",
      subtitle: "We create a home for international professionals in Switzerland",
      missionTitle: "Our Mission",
      missionText: "FeelAtHomeNow was founded to make the transition to Switzerland easier for international professionals, expats and companies. We don't just provide housing – we provide a real home.",
      visionTitle: "Our Vision",
      visionText: "We aim to become the leading provider of flexible housing solutions in Switzerland – known for quality, service and reliability.",
      valuesTitle: "Our Values",
      value1: "Quality",
      value1Desc: "Premium apartments in top locations",
      value2: "Service",
      value2Desc: "Personal and professional customer service",
      value3: "Flexibility",
      value3Desc: "Tailored solutions for individual needs",
      value4: "Reliability",
      value4Desc: "Trusted partnerships and guaranteed services",
    },
  },
};
